import { useEventContext } from "../../../context/EventContext/EventContext";
import { EventPreviewLocalizableFormData, EventTextRules } from "../../../context/EventContext/constants";
import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import TextareaComponent from "../../../components/TextareaComponent";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { PreviewImageUpload, PreviewTextConstants } from "./constants";
import { CultureProps } from "../constants";

const EventPreviewDetail = ({ Culture }: CultureProps) => {
	const { eventEditForm: eventUpdateForm, setEventEditForm: setEventUpdateForm, eventDetail } = useEventContext();

	if (!eventUpdateForm) {
		return null;
	}

	const fields = PreviewTextConstants[Culture];

	const localized = eventUpdateForm.eventPreview.eventPreviewLocalizable.find(x => x.culture === Culture);
	const defaultImageUrl = eventDetail?.eventPreview?.eventPreviewLocalizable.find(x => x.culture === Culture)?.imageUrl;

	const handleChange = <K extends keyof EventPreviewLocalizableFormData>(key: K, value: EventPreviewLocalizableFormData[K]) => {
		setEventUpdateForm(prev => prev ? {
			...prev,
			eventPreview: {
				...prev.eventPreview,
				eventPreviewLocalizable: prev.eventPreview.eventPreviewLocalizable.map(item =>
					item.culture === Culture ? { ...item, [key]: value } : item
				),
			},
		} : null);
	};

	return (
		<>
			<Row gutter={[20, 20]}>
				<Col xs={24} sm={24} md={12} lg={12}>
					<InputComponent
						title={fields.header.label}
						placeholder={fields.header.placeholder}
						value={localized?.header}
						maxLength={EventTextRules.previewHeaderMaxLength}
						onChange={e => handleChange("header", e.target.value)}
					/>
					<TextareaComponent
						title={fields.previewText.label}
						placeholder={fields.previewText.placeholder}
						rows={10}
						resizable={false}
						value={localized?.previewText}
						limitCharacter={EventTextRules.previewTextMaxLength}
						lineBreaks={EventTextRules.lineBreaks}
						onChange={e => handleChange("previewText", e.target.value)}
					/>
				</Col>
				<Col xs={24} sm={24} md={12} lg={12}>
					<FileUploadComponent
						title={fields.image.label}
						maxFileSize={PreviewImageUpload.maxFileSize}
						dimensions={PreviewImageUpload.dimensions}
						allowedExtensions={PreviewImageUpload.extensions}
						defaultUrl={defaultImageUrl}
						onChange={(files: FileData[] | null) => handleChange("image", files?.[0]?.file ?? null)}
					/>
				</Col>
			</Row>
		</>
	);
};

export default EventPreviewDetail;
